import { ValidUtils } from "../valid/ValidUtils.js";
var RandomUtils;
((RandomUtils2) => {
  RandomUtils2.uniqueInts = (min, max, count) => {
    const result = [];
    if (count > max - min) {
      throw new Error("Count is greater than the range of unique integers");
    }
    while (result.length < count) {
      const randomInt = RandomUtils2.int(min, max);
      if (!result.includes(randomInt)) {
        result.push(randomInt);
      }
    }
    return result;
  };
  RandomUtils2.chance = (percentage) => {
    if (percentage < 0 || percentage > 1) {
      throw new Error("Percentage must be between 0 and 1");
    }
    return Math.random() < percentage;
  };
  RandomUtils2.int = (min, max) => {
    return Math.floor(RandomUtils2.float(min, max));
  };
  RandomUtils2.float = (min, max) => {
    if (ValidUtils.isNullOrUndefined(min)) {
      return Math.random();
    } else if (!ValidUtils.isNullOrUndefined(min) && ValidUtils.isNullOrUndefined(max)) {
      return Math.random() * (min || 0);
    } else {
      return Math.random() * ((max || 0) - (min || 0)) + (min || 0);
    }
  };
  RandomUtils2.uuid = (format = "xxxx-xxxx-xxxx-xxxx") => {
    return format.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    });
  };
  RandomUtils2.uuid4 = () => {
    let uuid2 = "";
    let ii;
    for (ii = 0; ii < 32; ii += 1) {
      switch (ii) {
        case 8:
        case 20:
          uuid2 += "-";
          uuid2 += (Math.random() * 16 | 0).toString(16);
          break;
        case 12:
          uuid2 += "-";
          uuid2 += "4";
          break;
        case 16:
          uuid2 += "-";
          uuid2 += (Math.random() * 4 | 8).toString(16);
          break;
        default:
          uuid2 += (Math.random() * 16 | 0).toString(16);
      }
    }
    return uuid2;
  };
  RandomUtils2.hex = () => {
    const letters = "0123456789ABCDEF".split("");
    let hex2 = "";
    for (let i = 0; i < 6; i++) {
      hex2 += letters[Math.floor(Math.random() * 16)];
    }
    return hex2;
  };
  RandomUtils2.rgb = () => {
    const letters = "0123456789ABCDEF".split("");
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };
  RandomUtils2.rgba = () => {
    const letters = "0123456789ABCDEF".split("");
    let color = "#";
    for (let i = 0; i < 8; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };
  RandomUtils2.alphabet = (len) => {
    const letters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    let color = "";
    for (let i = 0; i < len; i++) {
      color += letters[Math.floor(Math.random() * letters.length)];
    }
    return color;
  };
})(RandomUtils || (RandomUtils = {}));
export {
  RandomUtils
};
//# sourceMappingURL=RandomUtils.js.map
